import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style, styleVariants } from '@vanilla-extract/css';

export const titleVariants = styleVariants({
  sm: typography.labelSm,
  md: typography.titleMd,
});

export const descriptionVariants = styleVariants({
  sm: typography.labelSm,
  md: typography.labelMd,
});

export const collapsibleLabel = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s4,
  cursor: 'pointer',
  marginBottom: space.s4,
});

export const collapsibleLabelIcon = style({
  marginLeft: 'auto',
});
